window.$ = jQuery;

$(document).ready(function () {
  let pageTemplate = $('body').attr('id');
  let isMobile;

  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    isMobile = true;
  } else {
    isMobile = false;
  }

  // let pdpLightbox = {
  //   slideshow: function () {
  //     $(".js-lightboxSlides").slick({
  //       prevArrow: ".js-slideshowArrow.prev",
  //       nextArrow: ".js-slideshowArrow.next",
  //       dots: true,
  //       appendDots: ".js-slideshowDots",
  //     });
  //   },
  //   init: function () {
  //     let lightboxEl = ".js-pdpLightbox";
  //     let lightboxToggleEl = ".js-lightboxToggle";
  //     let closeLightboxEl = ".js-closeLightbox";

  //     pdpLightbox.slideshow();

  //     $(lightboxToggleEl).on("click", function () {
  //       let index = $(this).attr("data-index");
  //       $(".js-lightboxSlides").slick("slickGoTo", index - 1, false);

  //       $("html").addClass("lightbox-open");
  //       $(lightboxEl).removeClass("hidden");
  //     });

  //     $(closeLightboxEl).on("click", function () {
  //       $(lightboxEl).addClass("hidden");
  //       $("html").removeClass("lightbox-open");
  //     });
  //   },
  // };

  // let pdpMobile = {
  //   slideshow: function (el) {
  //     el.slick({
  //       dots: true,
  //       appendDots: ".js-mobileSlideshowDots",
  //     });
  //   },
  //   tooltip: function ($el) {
  //     let $tooltip = $el.find(".js-infoTooltip");

  //     if ($tooltip.hasClass("open")) {
  //       $tooltip.removeClass("open");
  //     } else {
  //       $tooltip.addClass("open");
  //     }
  //   },
  //   init: function () {
  //     let slideshowEl = ".js-mobileSlides";
  //     let toggleEl = ".js-infoToggle";
  //     pdpMobile.slideshow($(slideshowEl));

  //     $(toggleEl).click(function () {
  //       pdpMobile.tooltip($(toggleEl));
  //     });
  //   },
  // };

  // let sizeChartLightbox = {
  //   init: function () {
  //     let lightboxEl = ".js-sizeLightbox";
  //     let lightboxToggleEl = ".js-sizechart-toggle";
  //     var no;
  //     let closeLightboxEl = ".js-closeLightbox";

  //     $(lightboxToggleEl).on("click", function () {
  //       no = $(this).data("box");
  //       $("html").addClass("lightbox-open");
  //       $(lightboxEl).addClass("size_" + no);
  //       $(lightboxEl).removeClass("hidden");
  //     });

  //     $(closeLightboxEl).on("click", function () {
  //       $(lightboxEl).removeClass("size_" + no);
  //       $(lightboxEl).addClass("hidden");
  //       $("html").removeClass("lightbox-open");
  //     });
  //   },
  // };

  // let pdpDropdowns = {
  //   init: function () {
  //     let dropdownEl = ".js-dropdown";
  //     let dropdownToggleEl = ".js-dropdownToggle";
  //     let dropdownArrowEl = ".js-dropdownArrow";
  //     let dropdownContentEl = ".js-dropdownContent";

  //     let $descriptionEl = $(dropdownEl + ".product-description").find(
  //       dropdownToggleEl
  //     );
  //     $descriptionEl.siblings(dropdownContentEl).slideDown("fast");
  //     $descriptionEl.find(dropdownArrowEl).addClass("open");

  //     $(dropdownToggleEl).click(function () {
  //       $(dropdownToggleEl)
  //         .not($(this))
  //         .each(function () {
  //           let $content = $(this).siblings(dropdownContentEl);
  //           let $arrow = $(this).find(dropdownArrowEl);
  //           $content.slideUp("fast");
  //           $arrow.removeClass("open");
  //         });
  //       let $content = $(this).siblings(dropdownContentEl);
  //       let $arrow = $(this).find(dropdownArrowEl);
  //       $content.slideToggle("fast");
  //       $arrow.toggleClass("open");
  //     });
  //   },
  // };

  // let pdpWaitlist = {
  //   onSubmit: function (event) {
  //     event.preventDefault();
  //     let $emailInput = $(this).siblings(".js-oos-email");
  //     let email = $emailInput.val();

  //     if (email && pdpWaitlist.validateEmail(email)) {
  //       let product = $emailInput.attr("data-product");
  //       let variant = $emailInput.attr("data-variant");
  //       $(".js-oos-errors").hide();
  //       pdpWaitlist.sendData(email, product, variant);
  //     } else {
  //       pdpWaitlist.showError("Please enter a valid email.");
  //     }
  //   },
  //   validateEmail: function (email) {
  //     const re =
  //       /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  //     if (re.test(String(email).toLowerCase())) {
  //       return true;
  //     } else {
  //       pdpWaitlist.showError("Please enter a valid email.");
  //       return false;
  //     }
  //   },
  //   sendData: function (email, product, variant) {
  //     var myHeaders = new Headers();
  //     myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

  //     var urlencoded = new URLSearchParams();
  //     urlencoded.append("a", "JJxzMA");
  //     urlencoded.append("email", email);
  //     urlencoded.append("variant", variant);
  //     urlencoded.append("product", product);
  //     urlencoded.append("platform", "shopify");

  //     var requestOptions = {
  //       method: "POST",
  //       headers: myHeaders,
  //       body: urlencoded,
  //       redirect: "follow",
  //     };

  //     fetch(
  //       "https://a.klaviyo.com/onsite/components/back-in-stock/subscribe",
  //       requestOptions
  //     )
  //       .then((response) => response.text())
  //       .then((result) => pdpWaitlist.onSuccess(result))
  //       .catch((error) => pdpWaitlist.showError(error));
  //   },
  //   showError: function (error) {
  //     $(".js-oos-errors").html(error);
  //     $(".js-oos-errors").show();
  //   },
  //   onSuccess: function (result) {
  //     $(".js-out-of-stock").hide();
  //     $(".oos-note").hide();

  //     $("#AddToCart").show();
  //     $("#AddToCart").find("span").html("Thanks for signing up");
  //     $(".shipping-note").show();
  //     // $('.shipping-note').html("Thank you for signing up! We'll be in touch when the product is back in stock.")
  //   },
  //   init: function () {
  //     $(".js-oos-submit").on("click", pdpWaitlist.onSubmit);
  //   },
  // };

  // let quickViewSlideShow = {
  //   slideshow: function () {
  //     $(".js-quickViewSlides").slick({
  //       dots: true,
  //       arrows: false,
  //     });
  //   },
  //   init: function () {
  //     $("#ShopNowContainer").on("classChange", function () {
  //       quickViewSlideShow.slideshow();
  //     });
  //   },
  // };

  let reviewsSection = {
    loadReviews: function (page) {
      let $container = $('.js-reviewsContainer');
      let prodId = $container.attr('data-id');
      let judgeMeKey = window.btoa('jFfbUewQordvp3E39xzas_HGKp0');
      let url = `https://judge.me/api/v1/widgets/product_review?api_token=${window.atob(
        judgeMeKey
      )}&shop_domain=project-maverick.myshopify.com&external_id=${prodId}&json_request=json&page=${page}`;

      let settings = {
        async: true,
        crossDomain: true,
        url: url,
        method: 'GET',
      };

      $.ajax(settings).done(function (response) {
        if (response.total_pages > response.current_page) {
          $('.js-loadReviews').css('display', 'block');
          $('.js-loadReviews').attr('data-page', response.current_page + 1);
        } else {
          $('.js-loadReviews').css('display', 'none');
        }
        reviewsSection.createReviews(response.reviews, response.per_page);
      });
    },
    createReviews: function (reviews) {
      if (reviews.length) {
        let $container = $('.js-reviewsContainer');

        let reviewsHtml = reviews
          .map((review) => {
            let name = review.reviewer_name,
              date = review.created_at.split('T')[0],
              rating = review.rating,
              title = review.title,
              body = review.body_html;
            let day = date.split('-')[2],
              month = reviewsSection.formatMonth(date.split('-')[1]),
              year = date.split('-')[0];
            let starHtml = [];

            for (i = 0; i < rating; i++) {
              starHtml.push('<span class="review-star"></span>');
            }

            return `
            <div class="review-card">
              <div class="review-card__inner">
                <div class="review-card__name">
                  <h4>${name}</h4>
                  <p>${month} ${day}, ${year}</p>
                </div>
                <div class="review-card__stars">
                  ${starHtml.join('')}
                </div>
                <div class="review-card__body">
                  <h4>${title}</h4>
                  ${body}
                </div>
              </div>
            </div>
          `;
          })
          .join('');

        $container.append(reviewsHtml);
      } else {
        $('div#shopify-section-product-reviews').hide();
      }
    },
    formatMonth: function (num) {
      let month;

      switch (num) {
      case '01':
        month = 'January';
        break;
      case '02':
        month = 'February';
        break;
      case '03':
        month = 'March';
        break;
      case '04':
        month = 'April';
        break;
      case '05':
        month = 'May';
        break;
      case '06':
        month = 'June';
        break;
      case '07':
        month = 'July';
        break;
      case '08':
        month = 'August';
        break;
      case '09':
        month = 'September';
        break;
      case '10':
        month = 'October';
        break;
      case '11':
        month = 'November';
        break;
      case '12':
        month = 'December';
        break;
      }

      return month;
    },
    init: function () {
      reviewsSection.loadReviews(1);
      $('.js-loadReviews').click(function () {
        reviewsSection.loadReviews($(this).attr('data-page'));
      });

      $('.js-reviews-section-link').click(function (event) {
        event.preventDefault();
        if (isMobile) {
          $('html, body').animate({ scrollTop: $('#shopify-section-product-reviews').offset().top }, '100');
        } else {
          window.scrollTo({
            top: $('#shopify-section-product-reviews').position().top,
            behavior: 'smooth',
          });
        }
      });
    },
  };

  let pdpVideos = {
    onScroll: function (entries) {
      entries.forEach((entry) => {
        if (entry.intersectionRatio > 0) {
          setTimeout(function () {
            entry.target.play();
            entry.target.parentElement.classList.remove('show_play');
          }, 750);
        }
      });
    },
    init: function () {
      let videos = document.querySelectorAll('.js-lightboxToggle video');
      let config = {
        rootMargin: '0px 0px',
        threshold: 0.5,
      };
      let observer = new IntersectionObserver(pdpVideos.onScroll, config);

      videos.forEach((video) => {
        observer.observe(video);
      });
    },
  };

  let faqs = {
    showAnswer: function (el) {
      let question = el.text();
      let answer = el.attr('data-answer');
      let href = el.attr('href');
      let image = el.attr('data-image');

      window.history.pushState({}, question, href);
      $('.js-questions').fadeOut(500, function () {
        if (image) {
          $('.js-answer-container').prepend('<img style="display: block; margin: 16px 0;" src="' + image + '">');
        }
        $('.js-answer-container').prepend(answer);
        $('.js-answer-container').prepend('<h3>' + question + '</h3>');
        $('.js-answer').fadeIn(500);
      });
    },
    hideAnswer: function () {
      let url = window.location.href.split('?')[0];

      window.history.replaceState({}, 'FAQs', url);

      $('.js-answer').fadeOut(500, function () {
        $('.js-answer-container').empty();
        $('.js-questions').fadeIn(500);
      });
    },
    windowHandler: function (href) {
      if (href.includes('faqs') && href.includes('?=a')) {
        let url = href.split('?')[0];
        let el = $('.js-faq-answer[href="?' + url + '"]');
        faqs.showAnswer(el);
      } else if (href.includes('faqs') && !href.includes('?=a')) {
        faqs.hideAnswer();
        console.log(history);
      }
    },
    init: function () {
      $('.js-faq-answer').click(function (event) {
        let el = $(this);
        event.preventDefault();
        faqs.showAnswer(el);
      });

      $('.js-faq-back').click(function (event) {
        event.preventDefault();
        history.back();

        $('.js-answer').fadeOut(500, function () {
          $('.js-answer-container').empty();
          $('.js-questions').fadeIn(500);
        });
      });

      faqs.windowHandler(window.location.href);

      window.addEventListener('popstate', function () {
        faqs.windowHandler(window.location.href);
      });
    },
  };

  let giftCardPage = {
    state: {
      balance: 0,
    },
    updateVariant: function () {
      let variants = JSON.parse($('[data-gc-variants]').html());
      let currentVariant;

      variants.map((variant) => {
        if (variant.price == giftCardPage.state.balance) {
          currentVariant = variant.id;
        }
      });

      $('.js-gcId').val(currentVariant);
    },
    updateBalance: function (balance, action) {
      var newBalance;
      if (action === 'add') {
        giftCardPage.state.balance = Number(giftCardPage.state.balance) + Number(balance);
      } else if (action === 'minus') {
        giftCardPage.state.balance = Number(giftCardPage.state.balance) - Number(balance);
      }
      newBalance = giftCardPage.state.balance / 100;

      if (Number.isInteger(newBalance)) {
        newBalance = newBalance;
      } else {
        newBalance = newBalance + '0';
      }
      console.log(newBalance);
      $('.js-gcBalance').html('$' + newBalance);
      if (giftCardPage.state.balance !== 0) {
        $('.js-giftcardCheckout').html('Add to Cart');
      } else {
        $('.js-giftcardCheckout').html('Start giving some boots!');
      }
      giftCardPage.updateVariant();
    },
    onProductAdded: function (event) {
      event.preventDefault();
      let $button = $(event.currentTarget);
      let $quantityEl = $button.parent();
      let qty = parseInt($quantityEl.attr('data-quantity'));
      let action;

      if ($button.hasClass('add-balance')) {
        $quantityEl.attr('data-quantity', qty + 1);
        action = 'add';
      } else if ($button.hasClass('remove-balance')) {
        $quantityEl.attr('data-quantity', qty - 1);
        action = 'minus';
      }

      if ($quantityEl.attr('data-quantity') > 0) {
        $quantityEl.find('.remove-balance').css('display', 'block');
      } else {
        $quantityEl.find('.remove-balance').css('display', 'none');
      }

      if ($quantityEl.attr('data-quantity') == 2) {
        $quantityEl.find('.add-balance').addClass('disabled');
      } else {
        $quantityEl.find('.add-balance').removeClass('disabled');
      }

      giftCardPage.updateBalance($button.attr('data-balance'), action);
    },
    init: function () {
      $('.js-gcUpdateBalance').on('click', giftCardPage.onProductAdded);
      $('.js-giftcardCheckout').on('click', function (event) {
        if (giftCardPage.state.balance === 0) {
          event.preventDefault();
          if (isMobile) {
            $('html, body').animate(
              {
                scrollTop: $('#shopify-section-collection-template').offset().top,
              },
              '100'
            );
          } else {
            window.scrollTo({
              top: $('#shopify-section-collection-template').position().top,
              behavior: 'smooth',
            });
          }
        }
      });
    },
  };

  let signupPopup = {
    onSubmit: function (ev) {
      Cookies.set('userSignedUp', true);
      $('.js-signup').addClass('success');
      $('.js-signupClose').css('color', $('.js-success').attr('data-color'));
    },
    onClose: function (ev) {
      Cookies.set('signupClosed', true, { expires: 1 });
      $('html').removeClass('signup-open');
      setTimeout(function () {
        $('.js-signupPopup').hide();
      }, 1000);
    },
    show: function ($signup) {
      if (document.getElementsByClassName('js-signupPopup')[0].dataset.enable != 'false') {
        if ((Cookies.get('signupClosed') !== 'true' && Cookies.get('userSignedUp') !== 'true') || Shopify.designMode) {
          $signup.css('display', 'flex');
          setTimeout(function () {
            $('html').addClass('signup-open');
          }, 5000);
        }
      }
    },
    init: function () {
      let $signup = $('.js-signupPopup');
      let $close = $('.js-signupClose');
      console.log($close);
      let $submit;

      signupPopup.show($signup);
      $close.on('click', signupPopup.onClose);

      setTimeout(function () {
        $form = $signup.find('form');
        $submit = $signup.find('button[type="button"]');
        $form.on('submit', signupPopup.onSubmit);
        $submit.on('click', signupPopup.onSubmit);
      }, 3000);
    },
  };

  let footer = {
    accessibility: function () {
      let $links = $('.footer-article a');

      $links.each(function (index, el) {
        let url = $(el).attr('href');
        if (url.includes('accessibility')) {
          setTimeout(function () {
            $(el).replaceWith(function () {
              return '<span data-acsb="trigger">' + $(this).text() + '</span>';
            });
          }, 1000);
        }
      });
    },
    mailto: function () {
      let $links = $('.footer-article a');
      $links.each(function (index, el) {
        let url = $(el).attr('href');

        if (url.includes('mailto:') || url.includes('tel:')) {
          $(el).click(function (event) {
            event.preventDefault();
            window.open(url);
          });
        }
      });
    },
  };

  // pdpLightbox.init();
  // pdpMobile.init();
  // sizeChartLightbox.init();
  // pdpDropdowns.init();
  // pdpWaitlist.init();
  // quickViewSlideShow.init();
  // pdpVideos.init();
  reviewsSection.init();
  footer.accessibility();
  giftCardPage.init();
  signupPopup.init();

  document.addEventListener('shopify:section:load', function (event) {
    if (event.detail.sectionId == $('.js-signup').attr('data-id')) {
      signupPopup.init();
    }
  });

  document.addEventListener('shopify:block:select', function (event) {
    if (event.detail.blockId == $('.js-success').attr('data-id')) {
      $('.signup__popup-inner').hide();
      $('.js-success').show();
    } else {
      $('.signup__popup-inner').show();
      $('.js-success').hide();
    }
  });

  if (!isMobile) {
    footer.mailto();
  }

  if (pageTemplate == 'faqs') {
    faqs.init();
  }


  // Open Quick View
  const triggers = document.querySelectorAll('button[data-quickView]');
  triggers.forEach((trigger) => {
    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      window?.toggleDrawer(true, 'QuickView', trigger.dataset.id);
    });
  });

  // Accordion JS
  if (!customElements.get("accordion-wrapper")) {
    class Accordion extends HTMLElement {
      constructor() {
        super();
        this.options = this.dataset.options;
        this.items = this.querySelectorAll(".td-accordion__item");
        this.onlyOneActive = false;
        window.addEventListener("load", () => {
          this.bindEvents();
        });
      }

    bindEvents() {
      const el = this;
      this.items.forEach(function (item) {
        const toggle = item.querySelector(".td-accordion__toggle");
        if (toggle) {
          toggle.addEventListener("click", function (event) {
            event.preventDefault();
            el.toggle(item.dataset.item);
          });
          if (item.dataset.open) {
            el.toggle(item.dataset.item);
          }
        }

        const toggleNext = item.querySelector(".td-accordion__toggle-next");
        if (toggleNext) {
          toggleNext.addEventListener("click", function (event) {
            event.preventDefault(), el.toggle(parseInt(item.dataset.item) + 1);
          });
        }
      });
    }

    toggle(currentItem) {
        const el = this;
        this.items.forEach(function (item) {
          const content = item.querySelector(".td-accordion__content");
          if (!content) return;
          if (item.dataset.item == currentItem) {
            if (item.classList.contains("is-active")) {
              content.style.maxHeight = null;
            } else {
              content.style.maxHeight = content.scrollHeight + "px";
            }
            item.classList.toggle("is-active");
          } else if (el.onlyOneActive) {
            item.classList.remove("is-active");
            content.style.maxHeight = null;
          }
        });
      }
    }

    customElements.define("accordion-wrapper", Accordion);
  }
});
